const confirmationDialogStyles = {
    dialogTitle: {
      fontWeight: 600,
    },
    dialogContent: {
      marginBottom: 2,
    },
    dialogActions: {
      justifyContent: "space-between",
    },
  };
  
  export default confirmationDialogStyles;
  